import { Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogConfig as MatDialogConfig} from "@angular/material/legacy-dialog";
import { Subscription } from "rxjs";
import { first } from "rxjs/operators";
import { MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import * as _ from "lodash";

import { AppGlobals } from "../../app.globals";
import { IUser } from "../../_models";
import { PermitToStayService, AlertService, MediaWatcherService, UserService, StorageService } from "../../_services";

@Component({
    templateUrl: "permitToStayAppointmentsDialog.component.html",
    styleUrls: ["permitToStayAppointmentsDialog.component.css"]
})
export class PermitToStayAppointmentsDialogComponent implements OnInit, OnDestroy {
    currentUser: IUser;
    isMobile = false;
    mediaWatcherSubscription: Subscription;
    id: number;
    appointmentDataSource = new MatTableDataSource<any>();

    appointmentDisplayedColumns = ["id", "appointmentTypeDescription", "appointmentDate", "appointmentTime", "isMissedAppointment", "isChargeAdded", "payment"];

    constructor(private dialogRef: MatDialogRef<PermitToStayAppointmentsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: any,
        private formBuilder: UntypedFormBuilder,
        public dialog: MatDialog,
        private appGlobals: AppGlobals,
        private alertService: AlertService,
        private permitToStayService: PermitToStayService,
        private mediaWatcherService: MediaWatcherService,
        private storageService: StorageService,
        private userService: UserService) {
        this.currentUser = data.currentUser;
        this.id = data.id;
    }

    ngOnDestroy() {
        this.mediaWatcherSubscription.unsubscribe();
    }

    ngOnInit() {
        //this.googleAnalyticsService.logPageView("/immigrationAppointments");

        this.mediaWatcherSubscription = this.mediaWatcherService.isTabletLarge.subscribe(isMobile => {
            this.isMobile = isMobile;

            if (this.isMobile) {
                this.appointmentDisplayedColumns = ["appointmentTypeDescription", "appointmentDate", "appointmentTime", "isMissedAppointment", "isChargeAdded", "payment"];
            } else {
                this.appointmentDisplayedColumns = ["id", "appointmentTypeDescription", "appointmentDate", "appointmentTime", "isMissedAppointment", "isChargeAdded", "payment"];
            }
        });

        this.permitToStayService.getOrientationPermitToStayStudentAppointments(this.id)
            .pipe(first())
            .subscribe(result => {
                this.appointmentDataSource = new MatTableDataSource(result);
            });
    }

    close() {
        this.dialogRef.close();
    }
}